<template>
  <div>
    <CRow>
      <CCol sm="12">
        <ManagersTable
          :items="managers"
          hover
          striped
          border
          small
          fixed
          caption="Supervisores"
          @refresh="refreshItems"
          :permissions="permissions"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import ManagersTable from '../../components/managers/ManagersTable.vue'
import ws from '../../services/managers';
import account_ws from '../../services/account';
import store from '../../store'

export default {
  name: 'Managers',
  components: { ManagersTable },
  data: function () {
		return {
            managers: [],
            permissions: null
        }
  },
  mounted: async function() {
    this.loading();
    let response = await ws.get();

    if(response.type == "success"){
      this.managers = response.data;
    }

    let response2 = await account_ws.getInfo(); 

    if(response2.type == "success"){
      this.permissions = response2.data.user.permissions;
    }

    this.loaded();
  },
  methods: {
    async refreshItems (items){
      this.loading();
      this.managers = await items;
      this.loaded();
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
